// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__xFDym","content":"Consent_content__3l-p0","footer":"Consent_footer__1dcP-"};